import React, { useEffect, useState } from 'react';
import {getCvcLength} from '../../../../utils/payments/3ds';
import { Keyboard, Platform, TouchableWithoutFeedback } from 'react-native';

import { Input } from '../../../Interface/Forms/Inputs/Input';
import { Button } from '../../../Interface/Forms/Buttons/Button';
import BottomSheet from '../../../Interface/BottomSheet';

import {
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalSubtitle,
  InputGroup,
  Section,
  SectionTitle,
  PaymentInfo,
  Payment,
  BrandContainer,
  BrandImage,
  PaymentMethodInfo,
  PaymentTitle,
} from './styles';
import { SafeAreaView } from 'react-native-safe-area-context';
import { RFValue } from 'react-native-responsive-fontsize';

interface CVCModalProps {
  showModal: boolean;
  onDismiss: () => void;
  cardInfo: {
    brandImage: string;
    numberMasked: string;
    voucher: boolean | null;
  };
  onConfirm: (cvc: string) => void;
  isLoading?: boolean;
  buttonText?: string;
  brand?: string;
}

export function CVCModal({
  showModal,
  onDismiss,
  cardInfo,
  onConfirm,
  isLoading = false,
  buttonText = 'Confirmar compra',
  brand,
}: CVCModalProps) {
  const [cvc, setCvc] = useState('');

  useEffect(() => {
    if (showModal) {
      setCvc('');
    }
  }, [showModal]);

  const maxCvcLength = getCvcLength(brand);
  const isButtonEnabled = cvc.length >= maxCvcLength && !isLoading;

  function handleConfirmPress() {
    if (!isButtonEnabled) {return;}
    onConfirm(cvc);
  }

  return (
    <BottomSheet isOpen={showModal} onClose={onDismiss}>
      <TouchableWithoutFeedback
        onPress={() => Platform.OS !== 'web' && Keyboard.dismiss()}>
        <ModalContent>
          <SafeAreaView style={{ flex: 1 }}>
            <ModalHeader>
              <ModalTitle>Código de segurança</ModalTitle>
              <ModalSubtitle>
                Digite o código de segurança do cartão para concluir sua compra.
              </ModalSubtitle>
            </ModalHeader>

            <InputGroup style={{ paddingTop: RFValue(8) }}>
              <Input
                placeholder="Digite o CVC do cartão"
                labelText="Código de segurança:"
                keyboardType="number-pad"
                maxLength={maxCvcLength}
                onChangeText={setCvc}
                value={cvc}
                editable={!isLoading}
              />
            </InputGroup>

            <Section>
              <SectionTitle>Forma de pagamento</SectionTitle>
              <PaymentInfo>
                <Payment>
                  <BrandContainer>
                    <BrandImage source={{ uri: cardInfo.brandImage }} />
                  </BrandContainer>
                  <PaymentMethodInfo>
                    <PaymentTitle>
                      {cardInfo.numberMasked} ({cardInfo.voucher ? 'Vale' : 'Crédito'})
                    </PaymentTitle>
                  </PaymentMethodInfo>
                </Payment>
              </PaymentInfo>
            </Section>

            <Button
              title={buttonText}
              enabled={isButtonEnabled}
              loading={isLoading}
              onPress={handleConfirmPress}
            />
          </SafeAreaView>
        </ModalContent>
      </TouchableWithoutFeedback>
    </BottomSheet>
  );
}
